import 'application/src/scss/abo/overview.scss';

import {
  VisibilityWatcher
} from 'application/src/js/util.js';

// import 'application/src/images/abo/food.svg';
// import 'application/src/images/abo/worldmap.svg';
// import 'application/src/images/abo/reading-news-on-sofa.svg';

window.addEventListener('DOMContentLoaded', _ => {
  new VisibilityWatcher({
    elements: [
      document.querySelector('.overview-head'),
      ...document.querySelectorAll('.overview-content section')
    ]
  });

  const referencesSlider = new Glide(document.querySelector('section.references .glide'), {
    type: 'slider',
    gap: 11,
    perView: 5,
    bound: 0,
    breakpoints: {
      990: {
        perView: 4
      },
      750: {
        perView: 3
      },
      560: {
        perView: 2,
        gap: 11
      },
      480: {
        perView: 1,
        gap: 0
      }
    }
  }).mount();
  referencesSlider.on('move.after', _ => bLazy.revalidate());

  new Glide(document.querySelector('section.testimonials .glide'), {
    autoplay: 10000,
    bound: 0,
    gap: 0,
    perMove: 1,
    type: 'carousel'
  }).mount();

	if(document.querySelector('#form-abo-selection')) {
		new AboSelection();
	}

	if(document.querySelector('#payment-interval-btn')) {
		new PaymentIntervalSelection();
	}
	
  // [...document.querySelectorAll('section.faq .accordion')].map(acc => {
  //   new Accordion({
  //     element: acc
  //   });
  // });

  [
    document.querySelector('.ms-table'),
    document.querySelector('.ms.bronze'),
    document.querySelector('.ms.silver'),
    document.querySelector('.ms.gold')
  ].map(containerElement => {
    if (containerElement) new ToggleMembershipDetails(containerElement);
  });
});

class ToggleMembershipDetails {
  constructor(container) {
    this.container = container;
    this.toggleButtons = [...this.container.querySelectorAll('.ms-toggle-details a')];

    this.invisibleClass = 'details-visible';

    this.addEvents();
  }

  addEvents() {
    this.toggleButtons.map(button => {
      button.addEventListener('click', _ => {
        this.container.classList.toggle(this.invisibleClass);
      });
    });
  }
}

class AboSelection {
	constructor(args) {
		this.form = document.querySelector('#form-abo-selection');
		this.errorMessage = document.querySelectorAll('.no-abo-error');
		this.hiddenInput = this.form.querySelector('input[name="abomodelid"]');
		this.triggerButtons = this.form.querySelectorAll('.button.select-model');
		this.addEvents();
	}

	addEvents() {
		[...this.triggerButtons].map(button => {
			button.addEventListener('click', e => {
				const aboModelId = button.getAttribute('data-abo-model-id');
				this.hiddenInput.value = aboModelId;
				this.form.submit();
			});
		});
	}
}

class PaymentIntervalSelection {
	constructor(args) {
		this.paymentInterval  = document.getElementById('payment-interval');
	    this.monthlyBtn       = document.getElementById('monthly-btn');
	    this.yearlyBtn        = document.getElementById('yearly-btn');
	    this.period           = document.querySelectorAll('.period');
	    
		this.addEvents();
	}

    togglePrices(option) {
        this.priceFormat = document.querySelectorAll('.price');

        this.priceFormat.forEach(function(element) {
            element.innerHTML = (option === 'yearly') 
                ? element.getAttribute('data-yearly-price') 
                : element.getAttribute('data-monthly-price');
        });

        this.period.forEach(function(element) {
            element.innerHTML = (option === 'yearly') 
                ? element.getAttribute('data-yearly-period') + '<br>' +
                ' <span class="old-price">' + element.getAttribute('data-yearly-regular-price') + '</span>' +
                ' <span class="text-saving-price">' + element.getAttribute('data-price-saving-text') + '</span>'
                : element.getAttribute('data-monthly-period');
        });

        this.monthlyBtn.classList.toggle('active', option === 'monthly');
        this.yearlyBtn.classList.toggle('active', option === 'yearly');
    }

	addEvents() {
		this.monthlyBtn.addEventListener('click', e => {
	        e.preventDefault();
	        this.togglePrices('monthly');
	        this.paymentInterval.value = 1;
	    });

		this.yearlyBtn.addEventListener('click', e => {
	        e.preventDefault();
	        this.togglePrices('yearly');
	        this.paymentInterval.value = 12;
	    });
	}
}